<template>
  <el-card class="sticky-content">
    <div class="gadget">
      <el-avatar
        style="vertical-align:middle"
        fit="fill"
        v-if="user.avatar"
        size="medium"
      >
        <img
          loading="lazy"
          title="用户图片"
          alt="用户图片"
          :src="user.avatar"
        />
      </el-avatar>
      <el-avatar
        v-else
        style="vertical-align:middle"
        size="medium"
        icon="el-icon-user-solid"
      >
      </el-avatar>
      &nbsp;
      <span>{{ user.name }}</span>
    </div>
    <div v-if="user.introduction" class="gadget">
      <p>
        {{ user.introduction }}
      </p>
    </div>
    <div class="gadget">
      <p v-if="user.email">
        📧 <a :href="'mailto:' + user.email">{{ user.email }}</a>
      </p>
      <p>
        <router-link :to="'/users/' + user.id">
          ✍️ 话题和回复
        </router-link>
      </p>
      <p>
        <router-link
          v-if="user.subscribed"
          :to="'/users/' + user.id + '/profile'"
        >
          ️🌐 个人主页（会员专享）
        </router-link>
        <span v-else class="disabled">
          ️🌐 个人主页（会员专享）
        </span>
      </p>
      <p>
        <router-link :to="{ path: '/messages', query: { id: user.id } }"
          >✉️ 站内信
        </router-link>
      </p>
    </div>
    <div class="gadget">
      <div
        class="user_created_at"
        :title="user.created_at | moment('YYYY-MM-DD')"
      >
        注册于{{ user.created_at | moment("from") }}
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data: function() {
    return { user: {} };
  },
  props: ["id"], //user id
  methods: {
    fetchUser: function() {
      if (this.id !== undefined) {
        this.$axios
          .get(`/users/${this.id}`)
          .then(res => (this.user = res.data));
      }
    }
  },
  mounted: function() {
    this.fetchUser();
  }
};
</script>
<style>
.user_created_at {
  color: gray;
  font-size: 9px;
}
.disabled {
  color: var(--color-fg-muted);
}
</style>
